import React, { useState, useEffect } from "react";
import FeatherIcon from "feather-icons-react";
import { setAlertMessage } from "@reducers/alert.reducer";
import PermissionDeniedComponent from "@screens/permission-denied/permission-denied.component";
import { checkMenuAccess } from "@utils/menu-auth";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { menuUrl } from "../roles-list/model/roles-list.constants";
import MESSAGES from "@constants/messages.constants";
import PageHeadComponent from "@src/components/organisms/page-head/page-head.component";
import CardComponent from "@atoms/card/card.component";
import { breadCrumbs } from "../roles-list/model/roles-list.constants";
import RolePermissionTableComponent from "../components/role-permission-table.component";
import RoleFormComponent from "../role-form/role-form.component";
import {
  formatMenuDataForEdit,
  getIntermediateAndCheckedState,
  getAllMenus,
  editRoleApi,
} from "../role-form/role-form.component.service";
import { PRIMARY_KEY } from "@constants/app.constants";

const {
  ALERT_TYPES: { SUCCESS, ERROR },
  ROLE_ALERTS: { EDIT_ALERT },
} = MESSAGES;

const ActionContent = ({ handleSaveClick, handleBackClick }) => {
  return (
    <>
      <button
        type="button"
        className="btn btn-primary btn-sm"
        onClick={handleSaveClick}
      >
        <FeatherIcon icon="save" size={17} />
      </button>

      <button
        type="button"
        className="btn btn-outline-primary btn-sm ml-2"
        onClick={handleBackClick}
      >
        <FeatherIcon icon="arrow-left" size={17} />
      </button>
    </>
  );
};

const RolesEditComponent = () => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const [menus, setMenus] = useState();
  const [roleName, setRoleName] = useState(
    location?.state?.row?.role_name || ""
  );
  const isStateExists = location?.state;
  const [error, setError] = useState("");
  const menuAccess = checkMenuAccess(menuUrl, "write");
  const handleBackClick = () => {
    history.push(`/${menuUrl}`);
  };

  const [checkBoxState, setCheckBoxState] = useState({
    readPermission: false,
    createPermission: false,
    editPermission: false,
    deletePermission: false,
  });

  const [intermediateState, setIntermediateState] = useState({
    readPermission: false,
    createPermission: false,
    editPermission: false,
    deletePermission: false,
  });

  const handleChange = (e) => {
    if (e.target.value === "") {
      setError("Role name is required!");
    }
    setError("");
    setRoleName(e.target.value);
  };

  const onLoadData = async () => {
    const menuResponse = await getAllMenus();
    if (menuResponse.status) {
      const formatedMenu = formatMenuDataForEdit(
        menuResponse.data,
        location?.state?.row
      );
      // console.log("formatedMenu::", formatedMenu);
      const states = getIntermediateAndCheckedState(formatedMenu);
      setCheckBoxState(states.checkedState);
      setMenus(formatedMenu);
    }
  };
  // console.log(location);
  const handleRolesSubmit = async () => {
    if (roleName === "") {
      setError("Role name is required!");
      return;
    }
    // console.log({ menus, roleName });
    const formatedMenu = menus.map((menu) => {
      return {
        menu_id: menu[PRIMARY_KEY],
        read_permission: menu.readPermission,
        create_permission: menu.createPermission,
        edit_permission: menu.editPermission,
        delete_permission: menu.deletePermission,
      };
    });
    // console.log({ roleName, formatedMenu });
    // INFO : call edit api
    const editRolesResponse = await editRoleApi({
      roleId: location?.state?.row[PRIMARY_KEY],
      name: roleName,
      menus: formatedMenu,
    });
    // console.log({ editRolesResponse });
    // INFO : check api response and show relevant alert message
    if (editRolesResponse.status) {
      dispatch(setAlertMessage({ type: SUCCESS, message: EDIT_ALERT }));
      history.push(`/${menuUrl}`);
    } else {
      dispatch(
        setAlertMessage({ type: ERROR, message: editRolesResponse.message })
      );
    }
  };

  useEffect(() => {
    if (isStateExists === undefined) {
      history.push("/user-administration/roles");
    }
  }, [isStateExists]);

  useEffect(() => {
    onLoadData();
  }, []);

  return menuAccess ? (
    <>
      <PageHeadComponent
        title={"Edit Role"}
        breadCrumbs={[
          ...breadCrumbs,
          { name: "Edit ", menu_url: "/user-administration/roles/edit" },
        ]}
        actionContent={
          <ActionContent
            handleSaveClick={() => handleRolesSubmit()}
            handleBackClick={handleBackClick}
          />
        }
      />

      <CardComponent>
        <RoleFormComponent
          roleName={roleName}
          error={error}
          handleChange={handleChange}
        />
      </CardComponent>
      <CardComponent>
        <RolePermissionTableComponent
          templateModal={{ menus, checkBoxState, intermediateState }}
          templateEvents={{ setMenus, setCheckBoxState, setIntermediateState }}
        />
      </CardComponent>
    </>
  ) : (
    <PermissionDeniedComponent />
  );
};

export default RolesEditComponent;
